import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../assets/icons/Icon";
import Button from "./Button";
import IconButton from "./IconButton";
import { isMobileView } from "./CommonFunctions";
import CustomDrawer from "./CustomDrawer";
import ExportButton from "./ExportButton";

const ReportViewPage = ({
  reportConfig,
  subText,
  filters,
  footer = null,
  children,
  handleRemoveBtnClick,
  onExport,
  onRefresh,
  onApplyFilters,
  hideFooter,
  title,
  hideApplyFilterButton,
  loading,
  isInStock,
  inStockTotal,
}) => {
  const navigate = useNavigate();
  const [showExportOptions, setShowExportOptions] = useState(false);
  const [exportSelectedOption, setExportSelectedOption] = useState("");
  const dropdownRef = useRef(null);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);

  


  const [updatedFilter, setUpdatedFilter] = useState(filters);
  useEffect(() => {
    console.log("filters", filters);
    setUpdatedFilter(filters);

  }, [filters])

  const exportOptions = [
    { label: "CSV", value: "csv" },
    { label: "EXCEL", value: "excel" }
  ]

  const handleExportOptionSelect = (value) => {
    setExportSelectedOption(value);
    setShowExportOptions(false);
    // Call the onExport prop with the selected value
    if (onExport) {
      onExport(value);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowExportOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

const handleApply=()=>{
onApplyFilters();
setShowFilterDrawer(false);
}
const handleClear=()=>{
onRefresh();
setShowFilterDrawer(false);
}
  return (
    <>
  <div className={`bg-gray-soft-gradient h-screen flex flex-col lg:overflow-hidden sm:overflow-y-auto`}>
  {/* Header */}
  <div className="flex-none lg:px-3 lg:pt-3">
    <div className="relative z-10">
      <div className="bg-white/60 lg:rounded-t-2xl border border-gray-100 p-4 relative">
        {/* Mobile Remove Icon (top right) - Only visible on small screens */}
      

        <div className="flex flex-col md:flex-row items-start justify-between gap-5">
          {/* Left Side - Title and Stats */}
          <div className="w-full md:w-auto">
            <div className="flex justify-between   md:block">
              <h1 className="text-2xl font-bold text-gray-800 flex items-start">
                {reportConfig?.iconType && (
                  <span className="bg-indigo-100 text-indigo-600 p-2 rounded-lg mr-3 w-8 flex-shrink-0">
                    <Icon type={reportConfig?.iconType} />
                  </span>
                )}
                {reportConfig?.title || title}
              </h1>
              
              {/* Mobile Actions - Only visible on small screens */}
              <div className="md:hidden flex items-start  gap-2">
              
                
                <IconButton
                  onClick={onRefresh}
                  bgColor="#F5F5F5"
                  textColor="#5e5e5e"
                  newhover={true}
                  infoText={"Refresh"}
                  tooltipWidth="100px"
                  size="small"
                >
                  <Icon type="refresh" />
                </IconButton>
                  <IconButton
                  onClick={() => {setShowFilterDrawer(true)}}
                  bgColor="#F5F5F5"
                  textColor="#5e5e5e"
                  newhover={true}
                  infoText={"filter"}
                  tooltipWidth="100px"
                  size="small"
                >
                  <Icon type="filter" />
                </IconButton>
                   <span
            className="w-7 p-0 text-right text-gray-500 hover:text-gray-900 cursor-pointer "
            onClick={() => handleRemoveBtnClick || navigate(-1)}
          >
            <Icon type={"remove"} />
          </span>
              </div>
            </div>
            
            {((!isMobileView() && reportConfig?.title )&& !subText )&& (
              <p className="text-gray-500 mt-1 ml-11.5">
                Manage and view all your {reportConfig?.title?.toLowerCase()}
              </p>
            )}
            {subText &&  <p className="text-gray-500 mt-1 ml-11.5">
            {subText}
            </p>}
          </div>

          {/* Right Side - Search and Actions - Hidden on mobile */}
          <div className="hidden md:flex w-full md:w-auto flex-col gap-5">
            <div className="flex gap-5">
              {!isMobileView() && (
                <ExportButton
                  onExport={(value) => { onExport(value) }}
                />
              )}

              <IconButton
                onClick={onRefresh}
                bgColor="#F5F5F5"
                textColor="#5e5e5e"
                newhover={true}
                infoText={"Refresh"}
                tooltipWidth="100px"
              >
                <Icon type="refresh" />
              </IconButton>

              {/* Desktop Remove Icon - Hidden on mobile */}
              <span
                className="hidden md:block w-7 p-0 text-right text-gray-500 hover:text-gray-900 cursor-pointer mt-1.5"
                onClick={() => handleRemoveBtnClick || navigate(-1)}
              >
                <Icon type={"remove"} />
              </span>
            </div>
          </div>
        </div>

        {/* Filters section - Hidden on mobile */}
        <div className="hidden lg:grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 lg:grid-cols-6 gap-3 sm:gap-2 md:gap-5 lg:gap-5 mt-5">
          {updatedFilter}
          {!hideApplyFilterButton && (
            <div className="flex mt-7">
              <Button
                type="primary"
                onClick={onApplyFilters}
                loading={loading}
              >
                Apply Filter
              </Button>
            </div>
          )}
        </div>
        
        {isInStock && (
          <div className="px-5 pt-2 flex flex-col sm:flex-row sm:space-x-50 gap-2 sm:gap-0 items-start sm:items-center">
            <h1 className="text-[--list-item-gray]">Total Sales: <span className="font-semibold">{inStockTotal.totalsales}</span></h1>
            <h1 className="text-[--list-item-gray]">Total Purchase: <span className="font-semibold">{inStockTotal.totalpurchase}</span></h1>
            <h1 className="text-[--list-item-gray]">Total Quantity: <span className="font-semibold">{inStockTotal.totalqty}</span></h1>
          </div>
        )}
      </div>
    </div>
  </div>

  {/* Main Content */}
  <div className="flex-grow lg:px-3 overflow-hidden">
    {children}
  </div>

  {/* Footer */}
  {(!isMobileView()) && (
    <div className={`flex-none lg:px-3 lg:mb-3 backdrop-blur-sm ${hideFooter ? "bg-white/70 p-4 rounded-b-xl border border-gray-100 mx-3" : ""}`}>
      {!hideFooter && <>{footer}</>}
    </div>
  )}
</div>
    {showFilterDrawer && (
  <CustomDrawer
    title="Filters"
    setDrawer={setShowFilterDrawer}
    onClose={() => setShowFilterDrawer(false)}
     buttons={[
        { Label: "Clear", Type: "secondary", Icon: "roundedRemove" },
        { Label: "Search", Type: "primary", Icon: "search" },
      ]}
      onButtonClick={(label) => {
        if (label === "Search") {
          handleApply();
        } else if (label === "Clear") {
          handleClear();
        }
      }}
   
  >
    <div className="grid grid-cols-1 gap-3">
           <div className="mx-auto">
          <ExportButton
            onExport={(value) => { onExport(value) }}
          />
        </div>
      {updatedFilter}
    </div>
  </CustomDrawer>
)}

    </>
  );
};

export default ReportViewPage;